var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#B22234",
    d: "m0.84271,0l20.65319,0c0.70203,0 1.27375,0.56126 1.27375,1.25046l0,13.34237c0,0.6892 -0.57171,1.25046 -1.27375,1.25046l-20.65319,0c-0.70203,0.00413 -1.27375,-0.55714 -1.27375,-1.24633l0,-13.34649c0,-0.6892 0.57171,-1.25046 1.27375,-1.25046l0,0z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#FFFFFF",
    d: "m-0.42263,1.12665l23.19227,0c0.0042,0.04127 0.00841,0.08254 0.00841,0.12793l0,1.21332l-23.20909,0l0,-1.21744c0,-0.04127 0.0042,-0.08254 0.00841,-0.12381l0,0zm23.19648,2.4514l0,1.33713l-23.20488,0l0,-1.33713l23.20488,0l0,0zm0,2.4514l0,1.33713l-23.20488,0l0,-1.33713l23.20488,0l0,0zm0,2.4514l0,1.33713l-23.20488,0l0,-1.33713l23.20488,0l0,0zm0,2.4514l0,1.33713l-23.20488,0l0,-1.33713l23.20488,0l0,0zm0,2.4514l0,1.20919c0,0.04127 -0.0042,0.08667 -0.00841,0.12793l-23.18807,0c-0.0042,-0.03714 -0.00841,-0.08254 -0.00841,-0.12381l0,-1.20919l23.20488,0l0,-0.00413z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fill: "#3C3B6E",
    d: "m8.31284,0l0,8.53449l-8.74387,0l0,-7.28403c0,-0.6892 0.57171,-1.25046 1.27375,-1.25046l7.47012,0l0,0l0,0z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_5",
    fill: "#FFFFFF",
    points: "0.08603109381584773,1.180302358691911 0.3760924983111664,2.067592372572804 -0.3889968420858665,1.518710745308418 0.5610589750657482,1.518710745308418 -0.20823379117292617,2.067592372572804 0.08603109381584773,1.180302358691911 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_6",
    fill: "#FFFFFF",
    points: "0.08603109381584773,2.8971052490857403 0.3760924983111664,3.784396272450522 -0.3889968420858665,3.2355138600320004 0.5610589750657482,3.2355138600320004 -0.20823379117292617,3.784396272450522 0.08603109381584773,2.8971052490857403 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_7",
    fill: "#FFFFFF",
    points: "0.08603109381584773,4.613909373293211 0.3760924983111664,5.501199499338981 -0.3889968420858665,4.952317086920459 0.5610589750657482,4.952317086920459 -0.20823379117292617,5.501199499338981 0.08603109381584773,4.613909373293211 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_8",
    fill: "#FFFFFF",
    points: "0.08603109381584773,6.33071260018167 0.3760924983111664,7.218003174886945 -0.3889968420858665,6.669120762468424 0.5610589750657482,6.669120762468424 -0.20823379117292617,7.218003174886945 0.08603109381584773,6.33071260018167 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_9",
    fill: "#FFFFFF",
    points: "1.1117546971201477,0.3219006891652434 1.4060194454793873,1.2091909834583277 0.6367268158702473,0.660308963616874 1.5909859586685116,0.660308963616874 0.8174898030227382,1.2091909834583277 1.1117546971201477,0.3219006891652434 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_10",
    fill: "#FFFFFF",
    points: "1.1117546971201477,2.038703859971264 1.4060194454793873,2.9259942103467864 0.6367268158702473,2.377112470917524 1.5909859586685116,2.377112470917524 0.8174898030227382,2.9259942103467864 1.1117546971201477,2.038703859971264 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_11",
    fill: "#FFFFFF",
    points: "1.1117546971201477,3.7555079841787347 1.4060194454793873,4.642797661564998 0.6367268158702473,4.093916146465489 1.5909859586685116,4.093916146465489 0.8174898030227382,4.642797661564998 1.1117546971201477,3.7555079841787347 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_12",
    fill: "#FFFFFF",
    points: "1.1117546971201477,5.472311211067193 1.4060194454793873,6.359600888453457 0.6367268158702473,5.8107193733539475 1.5909859586685116,5.8107193733539475 0.8174898030227382,6.359600888453457 1.1117546971201477,5.472311211067193 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_13",
    fill: "#FFFFFF",
    points: "1.1117546971201477,7.189113989296146 1.4060194454793873,8.076404115341916 0.6367268158702473,7.527523048901912 1.5909859586685116,7.527523048901912 0.8174898030227382,8.076404115341916 1.1117546971201477,7.189113989296146 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_14",
    fill: "#FFFFFF",
    points: "2.141681680722911,1.180302358691911 2.4359464290821506,2.067592372572804 1.6666537994730106,1.518710745308418 2.6167083960674518,1.518710745308418 1.8474167866255016,2.067592372572804 2.141681680722911,1.180302358691911 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_15",
    fill: "#FFFFFF",
    points: "2.141681680722911,2.8971052490857403 2.4359464290821506,3.784396272450522 1.6666537994730106,3.2355138600320004 2.6167083960674518,3.2355138600320004 1.8474167866255016,3.784396272450522 2.141681680722911,2.8971052490857403 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_16",
    fill: "#FFFFFF",
    points: "2.141681680722911,4.613909373293211 2.4359464290821506,5.501199499338981 1.6666537994730106,4.952317086920459 2.6167083960674518,4.952317086920459 1.8474167866255016,5.501199499338981 2.141681680722911,4.613909373293211 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_17",
    fill: "#FFFFFF",
    points: "2.141681680722911,6.33071260018167 2.4359464290821506,7.218003174886945 1.6666537994730106,6.669120762468424 2.6167083960674518,6.669120762468424 1.8474167866255016,7.218003174886945 2.141681680722911,6.33071260018167 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_18",
    fill: "#FFFFFF",
    points: "3.1716085185875045,0.3219006891652434 3.4616703238627906,1.2091909834583277 2.696580783075774,0.660308963616874 3.646636545575575,0.660308963616874 2.877343624490095,1.2091909834583277 3.1716085185875045,0.3219006891652434 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_19",
    fill: "#FFFFFF",
    points: "3.1716085185875045,2.038703859971264 3.4616703238627906,2.9259942103467864 2.696580783075774,2.377112470917524 3.646636545575575,2.377112470917524 2.877343624490095,2.9259942103467864 3.1716085185875045,2.038703859971264 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_20",
    fill: "#FFFFFF",
    points: "3.1716085185875045,3.7555079841787347 3.4616703238627906,4.642797661564998 2.696580783075774,4.093916146465489 3.646636545575575,4.093916146465489 2.877343624490095,4.642797661564998 3.1716085185875045,3.7555079841787347 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_21",
    fill: "#FFFFFF",
    points: "3.1716085185875045,5.472311211067193 3.4616703238627906,6.359600888453457 2.696580783075774,5.8107193733539475 3.646636545575575,5.8107193733539475 2.877343624490095,6.359600888453457 3.1716085185875045,5.472311211067193 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_22",
    fill: "#FFFFFF",
    points: "3.1716085185875045,7.189113989296146 3.4616703238627906,8.076404115341916 2.696580783075774,7.527523048901912 3.646636545575575,7.527523048901912 2.877343624490095,8.076404115341916 3.1716085185875045,7.189113989296146 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_23",
    fill: "#FFFFFF",
    points: "4.1973321218918045,1.180302358691911 4.491595850083854,2.067592372572804 3.722304386380074,1.518710745308418 4.672358982974515,1.518710745308418 3.903066061889035,2.067592372572804 4.1973321218918045,1.180302358691911 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_24",
    fill: "#FFFFFF",
    points: "4.1973321218918045,2.8971052490857403 4.491595850083854,3.784396272450522 3.722304386380074,3.2355138600320004 4.672358982974515,3.2355138600320004 3.903066061889035,3.784396272450522 4.1973321218918045,2.8971052490857403 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_25",
    fill: "#FFFFFF",
    points: "4.1973321218918045,4.613909373293211 4.491595850083854,5.501199499338981 3.722304386380074,4.952317086920459 4.672358982974515,4.952317086920459 3.903066061889035,5.501199499338981 4.1973321218918045,4.613909373293211 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_26",
    fill: "#FFFFFF",
    points: "4.1973321218918045,6.33071260018167 4.491595850083854,7.218003174886945 3.722304386380074,6.669120762468424 4.672358982974515,6.669120762468424 3.903066061889035,7.218003174886945 4.1973321218918045,6.33071260018167 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_27",
    fill: "#FFFFFF",
    points: "5.227259105494568,0.3219006891652434 5.521524291068317,1.2091909834583277 4.752231369982837,0.660308963616874 5.7022856751009385,0.660308963616874 4.932994502873498,1.2091909834583277 5.227259105494568,0.3219006891652434 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_28",
    fill: "#FFFFFF",
    points: "5.227259105494568,2.038703859971264 5.521524291068317,2.9259942103467864 4.752231369982837,2.377112470917524 5.7022856751009385,2.377112470917524 4.932994502873498,2.9259942103467864 5.227259105494568,2.038703859971264 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_29",
    fill: "#FFFFFF",
    points: "5.227259105494568,3.7555079841787347 5.521524291068317,4.642797661564998 4.752231369982837,4.093916146465489 5.7022856751009385,4.093916146465489 4.932994502873498,4.642797661564998 5.227259105494568,3.7555079841787347 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_30",
    fill: "#FFFFFF",
    points: "5.227259105494568,5.472311211067193 5.521524291068317,6.359600888453457 4.752231369982837,5.8107193733539475 5.7022856751009385,5.8107193733539475 4.932994502873498,6.359600888453457 5.227259105494568,5.472311211067193 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_31",
    fill: "#FFFFFF",
    points: "5.227259105494568,7.189113989296146 5.521524291068317,8.076404115341916 4.752231369982837,7.527523048901912 5.7022856751009385,7.527523048901912 4.932994502873498,8.076404115341916 5.227259105494568,7.189113989296146 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_32",
    fill: "#FFFFFF",
    points: "6.252981834369848,1.180302358691911 6.547246436990918,2.067592372572804 5.777955264763477,1.518710745308418 6.7280095698815785,1.518710745308418 5.962919737618222,2.067592372572804 6.252981834369848,1.180302358691911 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_33",
    fill: "#FFFFFF",
    points: "6.252981834369848,2.8971052490857403 6.547246436990918,3.784396272450522 5.777955264763477,3.2355138600320004 6.7280095698815785,3.2355138600320004 5.962919737618222,3.784396272450522 6.252981834369848,2.8971052490857403 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_34",
    fill: "#FFFFFF",
    points: "6.252981834369848,4.613909373293211 6.547246436990918,5.501199499338981 5.777955264763477,4.952317086920459 6.7280095698815785,4.952317086920459 5.962919737618222,5.501199499338981 6.252981834369848,4.613909373293211 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_35",
    fill: "#FFFFFF",
    points: "6.252981834369848,6.33071260018167 6.547246436990918,7.218003174886945 5.777955264763477,6.669120762468424 6.7280095698815785,6.669120762468424 5.962919737618222,7.218003174886945 6.252981834369848,6.33071260018167 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_36",
    fill: "#FFFFFF",
    points: "7.2829082350199315,0.3219006891652434 7.577173420593681,1.2091909834583277 6.807880499508201,0.660308963616874 7.757936553484342,0.660308963616874 6.988643632398862,1.2091909834583277 7.2829082350199315,0.3219006891652434 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_37",
    fill: "#FFFFFF",
    points: "7.2829082350199315,2.038703859971264 7.577173420593681,2.9259942103467864 6.807880499508201,2.377112470917524 7.757936553484342,2.377112470917524 6.988643632398862,2.9259942103467864 7.2829082350199315,2.038703859971264 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_38",
    fill: "#FFFFFF",
    points: "7.2829082350199315,3.7555079841787347 7.577173420593681,4.642797661564998 6.807880499508201,4.093916146465489 7.757936553484342,4.093916146465489 6.988643632398862,4.642797661564998 7.2829082350199315,3.7555079841787347 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_39",
    fill: "#FFFFFF",
    points: "7.2829082350199315,5.472311211067193 7.577173420593681,6.359600888453457 6.807880499508201,5.8107193733539475 7.757936553484342,5.8107193733539475 6.988643632398862,6.359600888453457 7.2829082350199315,5.472311211067193 ",
    className: "st1"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_40",
    fill: "#FFFFFF",
    points: "7.2829082350199315,7.189113989296146 7.577173420593681,8.076404115341916 6.807880499508201,7.527523048901912 7.757936553484342,7.527523048901912 6.988643632398862,8.076404115341916 7.2829082350199315,7.189113989296146 ",
    className: "st1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.3a6d937f5de2164418977475a9e0ae5b.svg";
export { ForwardRef as ReactComponent };